
import FormMixins from './FormMixins'
import { Component, Mixins, Inject, Prop } from 'vue-property-decorator'
import ConstService, { OptionItem } from '@/service/ConstService'
import BaseAbstract from '@/abstract/BaseAbstract'

@Component
export default class FormRadio extends Mixins(FormMixins) {
  @Inject('formService')
  formService!: BaseAbstract

  @Prop()
  fieldService!: BaseAbstract

  @Prop({ default: false })
  bool!: boolean

  private props = {
    value: 'value',
    label: 'display_name'
  }

  private onChange(value: number) {
    this.$emit('change', value)
  }

  private options = [] as OptionItem[]

  created() {
    Object.assign(this.props, this.field.props)
    if (this.field.options && this.field.options.length > 0) {
      this.options = this.field.options
    } else {
      if (this.bool) {
        this.options = ConstService.getBoolOptions()
      } else {
        this.options = this.fieldService
          ? this.fieldService.getOptions(this.field.prop)
          : this.formService.getOptions(this.field.prop)
      }
    }
  }
}
